import api from './baseApi';

export const touchSession = async (): Promise<void> => {
    await api.post('Session/Touch');
};
